import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { ICartDeliveryInfoProductType } from '../../../cart/models/delivery/i-cart-delivery-info';

@Component({
  standalone: false,
  selector: 'product-availability-notice',
  templateUrl: './product-availability-notice.component.html',
  styleUrls: ['./product-availability-notice.component.scss']
})
export class ProductAvailabilityNoticeComponent implements OnInit, OnChanges {
  @Input() availableProductTypes: ICartDeliveryInfoProductType[];

  public productsWithUnavailableDays: { name: string; daysUnavailable: string[] }[];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.productsWithUnavailableDays = this.availableProductTypes.reduce((acc, { name, daysUnavailable }) => {
      if (daysUnavailable.length) {
        acc.push({
          name,
          daysUnavailable: daysUnavailable.map(d => d.charAt(0).toUpperCase() + d.slice(1).toLowerCase())
        });
      }
      return acc;
    }, []);
  }

  public getDayNameKey(day: string) {
    return `orderProcess.delivery.unavailableDays.days.${day.toLowerCase()}`;
  }

}
